import classNames from 'classnames'
import React from 'react'
import { Grid } from '../Grid'

export const HorizontalLine = () => (
  <Grid additionalClassName="my-60 sm:my-90 lg:my-120">
    <div
      className={classNames(
        'col-span-full border-b border-neutral-lighter',
        'sm:ml-90 sm:mr-90',
        'md:mx-0',
        'lg:col-start-2 lg:col-span-6 lg:-mx-30',
        'xl:col-start-2 xl:col-span-8 xl:mx-0',
        'xxl:col-start-3 xxl:col-span-10 xxl:-mx-30'
      )}
    ></div>
  </Grid>
)
